import axios from 'axios';
import { API_URL } from '../../lib/const';

export const fetchTemplates = (params) =>
  axios
    .get(`${API_URL}/contracts/templates`, {
      params,
    })
    .then((response) => response.data);

export const fetchTemplateDetails = (id) =>
  axios
    .get(`${API_URL}/contracts/templates/${id}`)
    .then((response) => response.data);

export const fetchDynamicTemplateFields = (params) =>
  axios
    .get(`${API_URL}/contracts/contract_field`, {
      params,
    })
    .then((response) => response.data);

export const updateTemplate = (id, data = {}) =>
  axios
    .patch(`${API_URL}/contracts/templates/${id}`, data)
    .then((response) => response.data)
    .catch((err) => {
      throw 'Erro ao atualizar, cheque se as informações estão presentes.';}
    );;

export const createTemplate = (data = {}) =>
  axios
    .post(`${API_URL}/contracts/templates`, data)
    .then((response) => response.data)
    .catch((err) => {
      throw 'Erro: Certifique de que todas as informações foram preenchidas.'}
    );

export const duplicateTemplate = (id, newTitle) =>
  axios
    .post(`${API_URL}/contracts/templates/${id}/duplicate`, {
      new_template_title: newTitle})
    .then((response) => response.data)
    .catch((err) => {
      throw 'Ocorreu um erro ao duplicar.';}
    );
